export const fetchUser = () => {
	const userInfo =
		localStorage.getItem("user") !== "undefined"
			? JSON.parse(localStorage.getItem("user"))
			: localStorage.clear();
	return userInfo;
};

export const fetchIsAdmin = () => {
	const userInfo =
		localStorage.getItem("isAdmin") !== "undefined" &&
		JSON.parse(localStorage.getItem("isAdmin"));

	return userInfo;
};

export const fetchCartItems = () => {
	const cartInfo =
		localStorage.getItem("cartItems") !== "undefined"
			? JSON.parse(localStorage.getItem("cartItems"))
			: localStorage.clear();

	console.log("localStorage: ", cartInfo ? cartInfo : []);
	return cartInfo ? cartInfo : [];
};
